import React, { useEffect } from 'react'
import styled from 'styled-components'
import LEOfferCard from 'tripPlanner/components/Bookmark/BookmarkCard/LEOfferCard'
import { isBedbank, isLEOffer, isTourOffer } from 'lib/offer/offerTypes'
import TourBookmarkCard from 'tripPlanner/components/Bookmark/BookmarkCard/TourBookmarkCard'
import { useInView } from 'react-intersection-observer'
import { TrackingProps } from 'contexts/trackingContext'
import { productImpressionSnowplow } from 'analytics/enhanced-ecommerce'
import { productImpressionObject } from 'analytics/eventDefinitions'
import { connect } from 'react-redux'
import BedbankCard from 'tripPlanner/components/Bookmark/BookmarkCard/BedbankCard'

interface Props {
  offer: App.Offer
  onClick: () => void
  tracking: TrackingProps
  position: number
  currency: string
}

const SmallerTourCard = styled(TourBookmarkCard)`
  width: 273px;
`

const SmallerLEOfferCard = styled(LEOfferCard)`
  width: 273px;
`

const SmallerBedbankCard = styled(BedbankCard)`
  width: 273px;
`

function StandaloneLocationSeededYmalListOffer(props: Props) {
  const { offer, onClick, tracking, position, currency } = props
  const { ref, inView } = useInView({ triggerOnce: true })

  useEffect(() => {
    if (inView && offer) {
      productImpressionSnowplow(
        currency,
        [productImpressionObject(offer, tracking.listName!, position)],
        {
          listId: tracking.listId!,
          listName: tracking.listName!,
        },
      )
    }
  }, [currency, inView, offer, position, tracking])

  if (isLEOffer(offer)) {
    if (isTourOffer(offer)) {
      return <SmallerTourCard ref={ref} offer={offer} onClick={onClick}
      target="_blank"/>
    }
    return <SmallerLEOfferCard ref={ref} offer={offer} onClick={onClick}
    target="_blank"/>
  } else if (isBedbank(offer)) {
    return <SmallerBedbankCard offer={offer}
    target="_blank"
    onClick={onClick}
    />
  }
  return null
}

function mapState(state: App.State) {
  return {
    currency: state.geo.currentCurrency,
  }
}

export default connect(mapState)(StandaloneLocationSeededYmalListOffer)
